import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    Underline,
    BoxHead,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import Table from "../../Components/Properties/VacancyReport/Table";
import SingleDatePicker from "../../Components/SingleDatePicker";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/Properties/VacancyReport/FilterModal";
import { IoFilter } from "react-icons/io5";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { Select_Location, Select_Property } from "../../Redux/actions";
import SummaryCard from "../../Components/Properties/VacancyReport/SummaryCard";

const VacancyByProperty = () => {
    const dispatch = useDispatch();
    const properties = useSelector((state) => state.PropertyReducer.property);
    const locations = useSelector((state) => state.LocationsReducer.locations);
    const [summary, setSummary] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const location = useSelector(
        (state) => state.SelectLocationReducer.selectLocation
    );
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterType, setFilterType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [apiData, setApiData] = useState();
    const [masterData, setMasterData] = useState();
    const [filterData, setFilterData] = useState();
    const [selectedProperty, setSelectedProperty] = useState(property);
    const defaultLocations = {
        id: 0,
        name: "All Locations",
        clientId: 0,
    };
    const [selectedLocation, setSelectedLocation] = useState(location);

    const btnRef = useRef(null);
    const [startDate, setStartDate] = useState(
        moment().format("YYYY-MM-DD")
    );

    // Combined filters state
    const [activeFilters, setActiveFilters] = useState({
        tenantPreference: null,
        amenities: [],
        roomSharing: null,
        vacancyType: null
    });

    const [hasActiveFilters, setHasActiveFilters] = useState(false);

    const query = `&checkDate=${startDate}&propId=${selectedProperty?.id}&s=${searchQuery}&t=${filterType}&locationId=${selectedLocation?.id}`;

    const fetchFunction = async () => {
        const response = await axios.get(`${Config.apiUrl}/client/list/bed/stats?${query}`, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) error = true;
        else {
            setApiData(res?.newDataX);
            setMasterData(res?.newDataX);
            const vacancyData = getVacantBedsByProperty(res?.newDataX, activeFilters);
            setFilterData(vacancyData);
            setSummary(vacancyData.summary);
            setIsFocused(true);
        }
    };

    const getError = (res) => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        if (selectedProperty || selectedLocation) {
            const handler = setTimeout(() => {
                getListMutate();
            }, 50);
            return () => {
                clearTimeout(handler);
            };
        }
    }, [selectedProperty, selectedLocation]);

    // Re-apply filters whenever activeFilters changes or masterData changes
    useEffect(() => {
        if (masterData) {
            const filteredData = getVacantBedsByProperty(masterData, activeFilters);
            setFilterData(filteredData);
            // setSummary(filteredData.summary);
            const hasAnyFilter = activeFilters.tenantPreference !== null ||
                activeFilters.amenities.length > 0 ||
                activeFilters.roomSharing !== null ||
                activeFilters.vacancyType !== null;
            setHasActiveFilters(hasAnyFilter);
        }
    }, [activeFilters, masterData]);

    const submitHandler = (date) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        setStartDate(formattedDate);
        const handler = setTimeout(() => {
            getListMutate();
        }, 50);
        return () => {
            clearTimeout(handler);
        };
    };

    const handlePropertySelect = (property) => {
        dispatch(Select_Location(defaultLocations));
        setSelectedProperty(property);
        setSelectedLocation(defaultLocations)
        setActiveFilters({
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        });
        setSelectedFilter(null);
    };

    const handleLocationSelect = (location) => {
        dispatch(Select_Property({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" }));
        setSelectedLocation(location);
        setSelectedProperty({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" })
        setActiveFilters({
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        });
        setSelectedFilter(null);
    };

    const getVacantBedsByProperty = (
        data,
        filters = {
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        }
    ) => {
        let grandTotalVacantBeds = 0;
        let overallSummaryVacantBeds = 0;

        const summary = {
            totalBeds: 0,
            totalVacantBeds: 0,
            occupancyPercentage: 0,
            maleVacancy: 0,
            femaleVacancy: 0,
            unisexVacancy: 0,
            singleSharing: 0,
            doubleSharing: 0,
            tripleSharing: 0,
            fourSharing: 0,
        };

        const properties = Object.entries(data)
            .map(([propertyId, property]) => {
                let totalVacantBeds = 0;
                let overallVacantBeds = 0;
                let singleSharing = 0;
                let doubleSharing = 0;
                let tripleSharing = 0;
                let threePlusSharing = 0;
                let propertyTotalBeds = 0;

                Object.values(property.floors).forEach(floor => {
                    const gender = Number(floor.gender || 0);

                    // Apply vacancy type filter at floor level
                    // if (
                    //     filters.vacancyType !== null &&
                    //     Number(floor.isFullyVacant) !== Number(filters.vacancyType)
                    // ) {
                    //     return;
                    // }

                    Object.values(floor.rooms || {}).forEach(room => {

                        const vacantBeds = Number(room.vacantBeds || 0);
                        const totalBeds = Number(room.totalBeds || 0);
                        const deadBeds = Number(room.deadBeds || 0);

                        // Always count for occupancy calculation
                        overallSummaryVacantBeds += vacantBeds;

                        // ALL rooms contribute to occupancy
                        propertyTotalBeds += totalBeds;
                        summary.totalBeds += totalBeds;

                        // Always count overall vacancy
                        overallVacantBeds += vacantBeds;

                        // Apply tenant preference filter
                        if (filters.tenantPreference !== null &&
                            Number(gender) !== Number(filters.tenantPreference)) {
                            return;
                        }

                        // Skip fully occupied rooms
                        if (!room.vacantBeds || Number(room.vacantBeds) === 0) {
                            return;
                        }

                        // Apply vacancy type filter
                        if (filters.vacancyType !== null) {

                            // Fully Vacant
                            if (Number(filters.vacancyType) === 1) {
                                if (vacantBeds !== totalBeds) {
                                    return;
                                }
                            }

                            // Partially Vacant
                            if (Number(filters.vacancyType) === 0) {
                                if (vacantBeds === totalBeds) {
                                    return;
                                }
                            }

                            // Dormant Beds
                            if (Number(filters.vacancyType) === 2) {
                                if (deadBeds <= 0) {
                                    return;
                                }
                            }
                        }

                        // Apply room-sharing filter
                        if (filters.roomSharing !== null) {
                            const vacantBeds = Number(room.vacantBeds || 0);

                            if (filters.roomSharing === "3+") {
                                if (vacantBeds < 4) {
                                    return;
                                }
                            } else if (vacantBeds !== Number(filters.roomSharing)) {
                                return;
                            }
                        }

                        // Apply amenities filter (room must contain ALL selected amenities)
                        if (filters.amenities?.length > 0) {
                            const roomAmenities = room.amenities
                                ?.split(",")
                                .map(a => a.trim().toLowerCase()) || [];

                            const hasAllAmenities = filters.amenities.every(a =>
                                roomAmenities.includes(a.toLowerCase())
                            );

                            if (!hasAllAmenities) {
                                return;
                            }
                        }

                        const bedsToCount =
                            Number(filters.vacancyType) === 2
                                ? deadBeds
                                : vacantBeds;

                        // Count valid vacant beds
                        //totalVacantBeds += vacantBeds;
                        totalVacantBeds += bedsToCount;
                        summary.totalVacantBeds += bedsToCount;

                        if (gender === 1) {
                            summary.maleVacancy += bedsToCount;
                        } else if (gender === 2) {
                            summary.femaleVacancy += bedsToCount;
                        } else {
                            summary.unisexVacancy += bedsToCount;
                        }

                        if (bedsToCount === 1) {
                            summary.singleSharing += 1;
                        } else if (bedsToCount === 2) {
                            summary.doubleSharing += 1;
                        } else if (bedsToCount === 3) {
                            summary.tripleSharing += 1;
                        } else if (bedsToCount > 3) {
                            summary.fourSharing += 1;
                        }

                        if (bedsToCount === 1) {
                            singleSharing += 1;
                        } else if (bedsToCount === 2) {
                            doubleSharing += 1;
                        } else if (bedsToCount === 3) {
                            tripleSharing += 1;
                        } else if (bedsToCount > 3) {
                            threePlusSharing += 1;
                        }
                    });
                });

                if (totalVacantBeds === 0) return null;

                grandTotalVacantBeds += totalVacantBeds;

                //const occupiedBeds = propertyTotalBeds - totalVacantBeds;
                const occupiedBeds = propertyTotalBeds - overallVacantBeds;

                const occupancyPercentage = propertyTotalBeds > 0
                    ? Number(((occupiedBeds / propertyTotalBeds) * 100).toFixed(1))
                    : 0;

                return {
                    propertyId,
                    id: propertyId,
                    name: property.propName,
                    gId: property.gId,
                    address: property.propAddress,
                    vacantBeds: totalVacantBeds,
                    tenantPreference: property.tenantPreference,
                    type: property.propType,
                    occupiedBeds,
                    totalBeds: propertyTotalBeds,
                    occupancyPercentage,
                    singleSharing,
                    doubleSharing,
                    tripleSharing,
                    threePlusSharing,
                };
            })
            .filter(Boolean);

        //const occupiedBeds = summary.totalBeds - summary.totalVacantBeds;
        const occupiedBeds = summary.totalBeds - overallSummaryVacantBeds;

        summary.occupancyPercentage = summary.totalBeds > 0
            ? Number(((occupiedBeds / summary.totalBeds) * 100).toFixed(1))
            : 0;

        return {
            properties,
            totalVacantBeds: grandTotalVacantBeds,
            summary
        };
    };

    // Updated to combine filters instead of replacing
    // const onApplyFilter = (value, label, type) => {
    //     setActiveFilters(prevFilters => {
    //         const newFilters = { ...prevFilters };

    //         if (type === 1) {
    //             newFilters.tenantPreference = Number(value);
    //         } else if (type === 2) {
    //             if (!newFilters.amenities.includes(value)) {
    //                 newFilters.amenities = [...newFilters.amenities, value];
    //             }
    //         } else if (type === 3) {
    //             newFilters.roomSharing = value === "4" ? "3+" : Number(value);
    //         }

    //         return newFilters;
    //     });

    //     setIsFilterOpen(false);
    // };
    const onApplyFilter = (filtersToApply) => {
        sessionStorage.removeItem("vacant_active_page");
        const newFilters = {
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        };

        filtersToApply.forEach((filter) => {
            if (filter.type === 1) {
                newFilters.tenantPreference = Number(filter.value);
            }

            if (filter.type === 2) {
                newFilters.amenities.push(filter.value);
            }

            if (filter.type === 3) {
                newFilters.roomSharing =
                    filter.value === "4" ? "3+" : Number(filter.value);
            }

            if (filter.type === 4) {
                newFilters.vacancyType = Number(filter.value);
            }
        });

        setActiveFilters(newFilters);
        setIsFilterOpen(false);

    };
    const handleFilterClose = () => {
        setIsFilterOpen(false);
        // Reset all filters
        setActiveFilters({
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        });
    };

    // const handleSummaryCardClick = (filter) => {
    //     if (!filter) {
    //         // Clear all filters
    //         setActiveFilters({
    //             tenantPreference: null,
    //             amenities: [],
    //             roomSharing: null
    //         });
    //         setSelectedFilter(null);
    //         return;
    //     }

    //     setSelectedFilter(filter);

    //     // Update filters based on summary card click (combine with existing)
    //     setActiveFilters(prevFilters => {
    //         const newFilters = { ...prevFilters };

    //         if (filter.type === "gender") {
    //             newFilters.tenantPreference = filter.value;
    //         } else if (filter.type === "sharing") {
    //             newFilters.roomSharing = filter.value === 4 ? "3+" : filter.value;
    //         }

    //         return newFilters;
    //     });
    // };
    const handleSummaryCardClick = (filter) => {
        sessionStorage.removeItem("vacant_active_page");
        if (!filter) {
            setActiveFilters({
                tenantPreference: null,
                amenities: [],
                roomSharing: null,
                vacancyType: null
            });
            setSelectedFilter(null);
            return;
        }

        setSelectedFilter(filter);

        const newFilters = {
            tenantPreference: null,
            amenities: [],
            roomSharing: null,
            vacancyType: null
        };

        if (filter.type === "gender") {
            newFilters.tenantPreference = filter.value;
        } else if (filter.type === "sharing") {
            newFilters.roomSharing = filter.value === 4 ? "3+" : filter.value;
        }

        setActiveFilters(newFilters);
        setHasActiveFilters(null)
    };
    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Vacancy By Property
                        <Underline />
                    </BoxTitle>
                </BoxHead>

                <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
                    <FilterModal
                        onApplyFilter={onApplyFilter}
                        handleClose={handleFilterClose}
                        setSelectedFilter={setSelectedFilter}
                        selectedFilter={selectedFilter}
                        activeFilters={activeFilters}
                    />
                </SideModal>

                {isFocused && summary && (
                    <SummaryCard
                        summaryData={summary}
                        onClick={handleSummaryCardClick}
                        selectedKey={selectedFilter}
                        activeFilters={activeFilters}
                    />
                )}

                <FilterTableWrapper>
                    <FilterWrapper className="grid grid-cols-1 md:grid-cols-[auto_1fr]  gap-4">
                        <div className="flex items-center">
                            <Text>
                                {activeFilters.vacancyType === 2 ? "Dormant Beds:" : "Vacant Beds:"}{" "}
                                <span className="font-semibold">
                                    {filterData?.totalVacantBeds || 0}
                                </span>
                            </Text>
                        </div>
                        <div className="flex gap-2 justify-end items-center">
                            <SingleDatePicker
                                submitHandler={submitHandler}
                                defaultLabel={moment(startDate).format("YYYY-MM-DD")}
                                initialDate={startDate}
                                minDate={new Date()}
                                maxDate={moment().add(1, "year").toDate()}
                            />
                            <PropertiesFilterDropdown
                                properties={properties}
                                selectedProperty={selectedProperty}
                                onPropertySelect={handlePropertySelect}
                                placeholder="Select Property"
                                className="min-w-[200px]"
                            />
                            <LocationsFilterDropdown
                                locations={locations}
                                selectedLocation={selectedLocation}
                                onSelect={handleLocationSelect}
                                placeholder="All Locations"
                                className="w-full md:w-[200px]"
                            />
                            <div className="relative">
                                <FilterBtn
                                    ref={btnRef}
                                    type="button"
                                    title="Category Filter"
                                    onClick={() => setIsFilterOpen((v) => !v)}
                                    className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
                                >
                                    <IoFilter size={14} color="#9CA3AF" />
                                </FilterBtn>
                                {/* Yellow dot when filter is applied */}
                                {hasActiveFilters && (
                                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                                )}
                            </div>
                        </div>
                    </FilterWrapper>


                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                apiData={filterData?.properties}
                            />
                        </TableWrapper>
                    )}
                </FilterTableWrapper>

                {error && !isLoading && <NotFoundModel />}
                {(isLoading || isRefetching) && <Loading />}
            </BoxContainer>
        </>
    );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button``;
const Text = tw.p`text-xs text-rose-500 font-semibold `;

export default VacancyByProperty;